<template>
  <Layout>
    <confirm-modal
      v-bind:bodyText="textConfirmDisabledModal"
      v-bind:show="confirmDisableModal"
      @confirm="onConfirmDisabled()"
      @hidden="confirmDisableModal = false"
    >
    </confirm-modal>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Main Service</h4>
            <div v-if="action !== 'new'" class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{
                createModel.applicationId
              }}</label>
            </div>
            <validationObserver ref="addServiceForm" tag="form">
              <form @submit.prevent="onSubmit">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Sequence</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="sequence"
                      name="Sequence"
                      :rules="{
                        required: true,
                      }"
                    >
                      <b-form-input
                        id="sequence"
                        value=""
                        type="number"
                        name="sequence"
                        v-model="createModel.sequence"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) && createModel.sequence,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <!-- <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Display Name</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="displayname"
                      name="Display Name"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="displayname"
                        name="displayname"
                        v-model="createModel.display_name"
                        type="text"
                        class="form-control"
                        placeholder="Display Name"
                        maxlength="30"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) && createModel.display_name,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div> -->
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Service Name</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="servicename"
                      name="Serivce Name"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="servicename"
                        name="servicename"
                        v-model="createModel.service_name"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.service_name,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">KeyCloak Client Id</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="keycloakclientid"
                      name="KeyCloak Client Id"
                    >
                      <input
                        id="keycloakclientid"
                        name="keycloakclientid"
                        v-model="createModel.keycloak_client_id"
                        type="text"
                        class="form-control"
                        placeholder="KeyCloak Client Id"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.keycloak_client_id,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Service Domain</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="servicedomain"
                      name="Serivce Domain"
                      :rules="{
                        required: true,
                      }"
                    >
                      <input
                        id="servicename"
                        name="servicename"
                        v-model="createModel.service_domain"
                        type="text"
                        class="form-control"
                        placeholder="Domain"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.service_domain,
                        }"
                        v-on:keyup="onValidateSerivceDomain($event)"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Service Type</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Serivce Type"
                      :rules="{ required: true }"
                    >
                      <multiselect
                        v-model="createModel.service_type"
                        :options="productTypeOptions"
                        :class="{ 'is-invalid': errors.length }"
                      ></multiselect>
                      <div v-if="errors.length" class="validate-invalid">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-lg-2 col-form-label">Project Type</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Project Type"
                      :rules="{ required: true }"
                    >
                      <multiselect
                        v-model="createModel.project_type"
                        :options="projectTypeOptions"
                        :class="{ 'is-invalid': errors.length }"
                      ></multiselect>
                      <div v-if="errors.length" class="validate-invalid">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Token Expiry</label>
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-lg-12 mb-4">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="label_token_expiry"
                          name="Token Expiry"
                          :rules="{
                            required: true,
                          }"
                        >
                          <b-form-input
                            id="label_token_expiry"
                            value="42"
                            type="number"
                            name="label_token_expiry"
                            v-model="createModel.token_expiry"
                            :class="{
                              'is-invalid': errors && errors.length,
                              'is-valid':
                                !(errors && errors.length) &&
                                createModel.token_expiry,
                            }"
                          ></b-form-input>
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="col-lg-12">
                        <div
                          class="btn-group btn-group-example mb-3"
                          role="group"
                        >
                          <b-button
                            v-for="(item, index) in tokenExpiryOptions"
                            :key="index"
                            variant="outline-secondary"
                            class="w-sm"
                            @click="createModel.token_expiry = item.value"
                          >
                            {{ item.name }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <!-- <div class="form-group row mb-4">
                  <h4 class="card-title mb-4">Detail Service</h4>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Company name</label>
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-lg-12 mb-4">
                        <b-form-input
                          id="label_company_info_name"
                          type="text"
                          name="label_company_info_name"
                          v-model="createModel.company_info.name"
                        ></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">My product</label>
                  <div class="col-lg-8">
                    <div class="card">
                      <div class="card-body">
                        <b-form>
                          <div class="row">
                            <div class="col-md-4">
                              <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                <template v-slot:header>
                                  <h5 class="my-0 text-primary">
                                    <i class="fas fa-lock"></i> OAuth
                                  </h5>
                                </template>
                                <h5 class="card-title mt-0">OFM login</h5>
                                <p
                                  class="card-text"
                                >The world's number one social login product.</p>
                                <hr/>
                                <div class="text-right">
                                  <b-form-checkbox size="lg" v-model="productOptions.oauth" switch class="mb-1">
                                    <label>{{ productOptions.oauth ? 'Enabled' : 'Disabled' }}</label>
                                  </b-form-checkbox>
                                </div>
                            </b-card>
                            </div>
                          </div>
                        </b-form>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Active"
                        style="margin-right: 10px"
                        >Active</b-form-radio
                      >
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Inactive"
                        style="margin-right: 10px"
                        >Inactive</b-form-radio
                      >
                    </div>
                  </div>
                </div> -->
                <div class="form-group mb-4 text-center">
                  <div class="button-items">
                    <button type="submit" class="btn btn-primary">Save</button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- detail -->
    <div class="card" v-if="showDataTable">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8"></div>
          <div class="col-md-4 mb-4">
            <div class="text-sm-right">
              <button
                @click="
                  $router.push({
                    name: 'parameter_detail',
                    params: { parameterId: 'new' },
                  })
                "
                type="button"
                class="btn btn-success waves-effect waves-light"
              >
                <i class="fa fa-plus"></i>
                Add parameter
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Size&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @change="onFilterService()"
                ></b-form-select
                >&nbsp;Records
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                <b-form-input
                  v-model="search"
                  type="search"
                  :placeholder="`Search in page ${pageNo} `"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <b-table
                class="table table-centered table-nowrap"
                ref="grouptable"
                :empty-text="'Not found any result'"
                :show-empty="items.length == 0"
                :bordered="true"
                :filter="search"
                :items="items"
                align="center"
                v-bind:fields="fields"
                @filtered="onFilteredParameter"
                :perPage="perPage"
              >
                <template v-slot:cell(index)="data">
                  <div class="text-right">
                    {{ firstRowOnPage + data.index }}
                  </div>
                </template>
                <template v-slot:cell(status)="data">
                  <span
                    class="label"
                    :class="'label-' + data.value.toLowerCase()"
                    v-html="data.value"
                  ></span>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="button-items">
                    <button
                      @click="
                        $router.push({
                          name: 'parameter_detail',
                          params: {
                            id: applicationId,
                            serviceId: serviceId,
                            parameterId: data.item.id,
                          },
                        })
                      "
                      type="button"
                      class="btn btn-warning waves-effect waves-light"
                      title="Edit"
                    >
                      <i class="mdi mdi-pencil label-icon"></i>
                    </button>
                    <button
                      @click="
                        onConfirmDelete(data.item.id, data.item.column_key)
                      "
                      type="button"
                      class="btn btn-danger waves-effect waves-light"
                      title="Delete"
                    >
                      <i class="mdi mdi-trash-can label-icon"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="row" v-if="items && items.length > 0">
          <div class="col-lg-4">
            <div style="position: relative; top: 7px">
              Result {{ firstRowOnPage }} - {{ lastRowOnPage }} From
              {{ totalRecords }} Records
            </div>
          </div>
          <div class="col-lg-8">
            <b-pagination
              :total-rows="totalRecords"
              :per-page="perPage"
              v-model="pageNo"
              @change="onClickPagination($event)"
              class="pagination pagination-rounded justify-content-end mb-2"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import serviceService from "@/helpers/service/service-provider";
import parameterService from "@/helpers/service/parameter-provider";
import { eventBus } from "@/main.js";
import Multiselect from "vue-multiselect";
import ConfirmModalComponnent from "@/components/share/modal-confirm.vue";
const _ = require("underscore");
// import {
//   ChannelAllowEnum,
//   ChannelAllowTypeEnum,
// } from "@/enum/application.enum.js";
import {
  SerivceTypeEnum,
  ProjectTypeEnum,
  ServiceProductEnum,
} from "@/enum/service.enum.js";
import { serviceComputed, serviceMethods } from "@/state/helpers";
/**
 * Projects-create component
 */
export default {
  page: {
    title: "Create New Service",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    "confirm-modal": ConfirmModalComponnent,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 120,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
      },
      applicationId: "",
      serviceId: "",
      action: "new",
      title: "Create New Service",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Service",
          href: "/Services",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      createModel: {
        applicationId: "",
        sequence: 0,
        // display_name: "",
        service_name: "",
        service_name_old: "",
        keycloak_client_id: "",
        service_domain: "",
        service_type: "",
        project_type: "",
        token_expiry: 0,
        audience_key: "",
        // company_info: {
        //   name: ""
        // },
        // products: []
      },

      oldData: {},
      productTypeOptions: ["Frontend", "Backend"],
      projectTypeOptions: ["Web", "Mobile"],
      tokenExpiryOptions: [
        { name: "1 ชั่วโมง", value: 60 },
        { name: "1 วัน", value: 1440 },
        { name: "1 ปี", value: 21900 },
      ],
      productOptions: {
        oauth: false,
      },
      isDuplicate: false,
      confirmDisableModal: false,
      confirmDisable: false,
      textConfirmDisabledModal:
        "ต้องการปิดการใช้งาน OAuth หรือไม่? หากปิดการใช้งานจะเกิดผลกระทบค่อนข้างมาก กรุณาพิจารณาอีกครั้ง",
      /* parameters list */
      showDataTable: false,
      fields: [
        {
          key: "index",
          label: "index",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "column_key",
          label: "Column Key",
          sortable: true,
        },
        {
          key: "column_name",
          label: "Column Name",
          sortable: true,
        },
        {
          key: "source_of_data",
          label: "Source of data",
          sortable: true,
        },
        {
          key: "source_of_data_type",
          label: "Source of data type",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 0,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 0,
            prevPage: 0,
            nextPage: 0,
          };
        },
      },
      items: [],
      pageNo: 0,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 50,
      filter: {
        name: "",
      },
      pageOptions: [5, 10, 25, 50, 100],
      search: null,
    };
  },
  computed: {
    ...serviceComputed,
  },
  created: function () {
    this.applicationId = this.$route.params.id;
    this.serviceId = this.$route.params.serviceId;
    if (this.serviceId === "new") {
      this.action = "new";
      this.title = "Create";
    } else {
      this.action = "edit";
      this.title = "Edit";
    }
  },
  mounted: function () {
    if (this.action === "edit") {
      this.getDetail();
    }
  },
  watch: {
    GET_FILTER_PARAMETER(val, oldVal) {
     // console.log("parameter", val, oldVal);
      this.filter = Object.assign({}, val);
    },
    listModel: function (value) {
      this.totalPages = value.totalPages;
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1;
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords);
      this.totalRecords = value.totalRecords;
      this.$refs.grouptable.localSortBy = "";
      this.items = value.items;
      this.perPage = value.pageSize;
      this.pageNo = value.pageNo;
    },
  },
  methods: {
    ...serviceMethods,
    async getDetail() {
      let result = await serviceService.getServiceAsync(
        this.applicationId,
        this.serviceId
      );
      if (result.status === 200) {
        this.createModel = result.data;
        // console.log('this.createModel', this.createModel)
        this.createModel.service_domain_old = result.data.service_domain;
        this.oldData = Object.assign({}, this.createModel);
        // my product
        // if(this.createModel.products.length) {
        //   for (let i = 0; i < this.createModel.products.length; i++) {
        //     if (this.createModel.products[i].type === ServiceProductEnum.OAUTH) this.productOptions.oauth = true
        //   }
        // }
        // console.log('start', this.createModel)
        await this.onFilterParameter();
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSubmit() {
      this.$refs.addServiceForm.validate().then(async (result) => {
        if (result) {
          if (this.action === "new") {
            // my product
            // if(this.productOptions.oauth)
            //     this.createModel.products.push({ type: ServiceProductEnum.OAUTH })
            let result = await serviceService.createServiceAsync(
              this.applicationId,
              this.createModel
            );
            if (result.status === 201) {
              // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
              this.$utils.notification("success", "Success", 1500);

              this.$router.push({
                name: "application_detail",
                params: { id: this.applicationId },
              });
              // this.clearForm();
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          } else {
            // let isChangeProduct = false;
            // if(
            //   this.productOptions.oauth
            //   && this.createModel.products.filter(q => q.type === ServiceProductEnum.OAUTH).length === 0
            // ) {
            //   this.createModel.products.push({ type: ServiceProductEnum.OAUTH })
            //   isChangeProduct = true
            // }
            // else if (
            //   !this.productOptions.oauth
            //   && this.createModel.products.filter(q => q.type === ServiceProductEnum.OAUTH).length > 0
            // ) {
            //   this.createModel.products = this.createModel.products.filter(q => !(q.type === ServiceProductEnum.OAUTH))
            //   isChangeProduct = true
            // }

            // if (_.isEqual(this.createModel, this.oldData) && !isChangeProduct) {
            //   this.$router.push({
            //     name: "application_detail",
            //     params: { id: this.applicationId }
            //   });
            //   return;
            // }

            // console.log(this.createModel.products)
            // if (!isChangeProduct)
            //   this.createModel.products = []

            let result = await serviceService.updateServiceAsync(
              this.applicationId,
              this.serviceId,
              this.createModel
            );
            if (result.status == 204) {
              // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
              this.$utils.notification("success", "Success", 1500);

              this.$router.push({
                name: "application_detail",
                params: { id: this.applicationId },
              });
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          }
        }
      });
    },
    onCancel() {
      this.$router.push({
        name: "application_detail",
        params: { id: this.applicationId },
      });
    },
    async onValidateSerivceDomain() {
      if (
        !(
          this.createModel.service_domain.trim() === "" ||
          this.createModel.service_domain.trim() === null ||
          this.createModel.service_domain.trim() === undefined
        )
      ) {
        if (
          this.action === "edit" &&
          this.createModel.service_domain_old ==
            this.createModel.service_domain.trim()
        ) {
          return;
        }

        let params = new URLSearchParams();
        params.append("service_domain", this.createModel.service_domain.trim());
        let result = await serviceService.headServiceAsync(
          this.applicationId,
          params
        );
        if (result.status === 200) {
          this.isDuplicate = true;
        } else if (result.response.status === 404) {
          this.isDuplicate = false;
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      }
    },
    clearForm() {
      this.createModel = {
        applicationId: "",
        sequence: 0,
        // display_name: "",
        service_name: "",
        service_name_old: "",
        keycloak_client_id: "",
        service_domain: "",
        service_type: "",
        project_type: "",
        token_expiry: 0,
        audience_key: "",
        // company_info: {
        //   name: ""
        // },
        // products: []
      };
    },
    onConfirmDisabled() {
      this.confirmDisableModal = false;
      this.confirmDisable = true;
      this.productOptions.oauth = false;
    },
    async onConfirmDelete(id, name) {
      await this.$utils
        .confirmAlertDisplay(
          `คุณต้องการลบข้อมูล ${name} ใช่หรือไม่`,
          ""
        )
        .then((result) => {
          if (result) {
            this.onDelete(id);
          }
        });
    },
    async onDelete(id) {
      let result = await parameterService.deleteParameterAsync(
        this.applicationId,
        this.serviceId,
        id);
      if (result.status && result.status === 200) {
        this.$utils.notification(
          "success",
          "ลบข้อมูลสำเร็จ",
          1500
        );
        await this.onFilterParameter();
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    /* List */
    async onFilteredParameter(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onClickPagination(pageNo) {
      await this.onFilterParameter(pageNo);
    },
    async onFilterParameter(pageNo = 0) {
      this.showDataTable = true;
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      if (pageNo > 0) params.append("pageNo", pageNo);
      params.append("name", this.filter.name.trim() || "");

      let result = await parameterService.getParametersAsync(
        this.applicationId,
        this.serviceId,
        params
      );
      if (result.status === 200) {
        this.listModel = result.data;
        //console.log(this.listModel);
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
      this.ADD_FILTER_SERVICE(this.filter);
    },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}
</style>
